<template>
  <!-- <el-select
      v-model="groupId"
      placeholder="请选择行业管理"
      clearable
      @change="handleChange"
    >
      <el-option
        v-for="item in list"
        :key="item.groupId"
        :label="item.groupName"
        :value="item.groupId"
      >
      </el-option>
    </el-select> -->
  <el-cascader
    v-model="selectedOptions"
    :options="list"
    :props="props"
  ></el-cascader>
</template>

<script>
export default {
  name: 'CategorySelectNew',
  components: {},
  props: {
    value: {
      required: true
    },
    callback: {
      type: Function
    },
    option: {
      type: Object
    }
  },
  data() {
    return {
      props: {
        label: 'className',
        value: 'classId'
      },
      list: []
    }
  },
  computed: {
    selectedOptions: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleChange() {
      this.callback && this.callback()
    },
    fetchList() {
      this.$store.dispatch('account/getcategorytree', {
        payload: {},
        success: (res) => {
          this.list = res.data.categorys
        },
        fail: () => {
          this.list = []
        }
      })
    }
  }
}
</script>
